module.exports = window.$;


//////////////////
// WEBPACK FOOTER
// external "window.$"
// module id = 211
// module chunks = 62